// Feature 009: Deal Operating System
// Blocker badge component for displaying blocking issues
// Design: Black (#000), Bone (#fffbf7), Sage (#a1c6a2)
import React from 'react';

const BlockerBadge = ({ issue }) => {
  if (!issue) return null;

  return (
    <div className="mt-2 flex items-start gap-2 p-2 border border-[#c47474] bg-[rgba(196,116,116,0.1)]">
      <div className="w-2 h-2 bg-[#c47474] flex-shrink-0 mt-1" />
      <span
        className="text-xs text-[#c47474] leading-tight"
        style={{ fontFamily: "'GT Pressura Mono', monospace" }}
      >
        {issue}
      </span>
    </div>
  );
};

export default BlockerBadge;
